import {
  INVALID_XML_NAME_CHARS_REGEX,
  VALID_XML_NAME_START_REGEX,
  XML_NAME_FALLBACK,
  XML_NAME_REPLACEMENT,
} from '../../constants';
import stripDiacritics from '../stripDiacritics';

const normalizeXmlName = (value: string): string => {
  // Transliterating first keeps 'číslo' and '1slo' apart; collapsing them both to '_' did not.
  const body = stripDiacritics(value.trim()).replace(
    INVALID_XML_NAME_CHARS_REGEX,
    XML_NAME_REPLACEMENT
  );

  if (!body) return XML_NAME_FALLBACK;

  return VALID_XML_NAME_START_REGEX.test(body)
    ? body
    : `${XML_NAME_REPLACEMENT}${body}`;
};

export default normalizeXmlName;
